import $ from 'jquery';
import debounce from './Debounce';

let anchorsStartPosition = null;

if (document.querySelector('.sticky-anchors')) {
    document.addEventListener('DOMContentLoaded', function() {
        if (!document.body.classList.contains('is-accessability')) {
            const stickyAnchors = document.querySelector('.sticky-anchors');

            if (stickyAnchors) {
                anchorsStartPosition = stickyAnchors.getBoundingClientRect().top;
                debounce(activateAnchor('h2[data-anchor]', 100));
            }
        }
    });

    window.addEventListener('scroll', function() {
        if (!document.body.classList.contains('is-accessability')) {
            stickyAnchors();
            debounce(activateAnchor('h2[data-anchor]', 100));
        }
    });
}

$('.js-select-anchors').on('change.select2', function(e) {
    const sectionId = e.target.value;
    if (sectionId) {
        scrollToSection(sectionId);
    }
});
$('.js-select-anchors').on('select2:closing', function(e) {
    $('.js-select-anchors')
        .val(null)
        .trigger('change');
});

document.addEventListener('click', function(e) {
    const target = e.target.closest('.sticky-anchors__item');

    if (target) {
        event.preventDefault();

        const sectionId = target.getAttribute('href').slice(1);

        scrollToSection(sectionId);
    }
});

function scrollToSection(sectionId) {
    const currentSection = document.querySelector(`h2[data-anchor="${sectionId}"]`);

    // Библиотека select2 делает скролл вверх, поэтому используем setTimeout
    setTimeout(() => {
        window.scrollTo({ top: currentSection.offsetTop + 20, behavior: 'smooth' });
    }, 1);
}

function stickyAnchors() {
    const anchors = document.querySelector('.sticky-anchors');
    const header = document.querySelector('.header__bottom');
    const headerHeight = header.clientHeight;

    if (window.scrollY > anchorsStartPosition) {
        anchors.style.top = `${headerHeight}px`;
        anchors.classList.add('active');
    } else {
        anchors.classList.remove('active');
    }
}

function activateAnchor(selector) {
    if (document.querySelectorAll(selector).length) {
        const elements = getElementsClosestToCenter(selector);
        const currentItem = elements[0];
        const sectionId = currentItem.item.dataset.anchor;

        const activeAnchor = document.querySelector('.sticky-anchors__item.active');
        if (activeAnchor) {
            activeAnchor.classList.remove('active');
        }

        const currentAnchor = document.querySelector(`.sticky-anchors__item[href="#${sectionId}"]`);
        currentAnchor.classList.add('active');
    }
}

function getElementsClosestToCenter(selector) {
    const itemsList = document.querySelectorAll(selector);
    const itemsTop = [];
    itemsList.forEach(function(item) {
        itemsTop.push({
            item: item,
            top: item.getBoundingClientRect().top
        });
    });
    itemsTop.sort(function(a, b) {
        return a < 0 ? -1 : Math.abs(window.innerHeight / 2 - a.top) - Math.abs(window.innerHeight / 2 - b.top);
    });
    return itemsTop;
}
